import { extend } from "../helpers/object-util.js";
import chartBuilderBase from "./chartBuilderBase.js";

/**
 * Builds default series options http://api.highcharts.com/highcharts#series
 *
 * @param {object} spec - Parameter object
 * @param {object} my - protected fields holder
 * @return {{}}
 */
function seriesBuilder(spec, my) {
	spec ||= {};
	my ||= {};

	const builderSpec = Object.create(spec);

	builderSpec.options = chartBuilderBase.mergeOptions(
		builderSpec.options || {},
		{
			borderWidth: 0,
		},
	);

	const pointOptions = {};

	const that = chartBuilderBase(builderSpec, my);
	my.myself = that;

	that.build = function () {
		return my.buildSeriesOption();
	};

	that.setData = function (data) {
		return my.setOption("data", data);
	};

	that.setOptionsForPoint = function (options) {
		pointOptions[options.pointIndex] = options.options;
		return my.myself;
	};

	that.ofTypeLine = function (options) {
		my.setOption("type", "line");
		my.setOption("color", options.color);
		my.setOption("lineWidth", options.lineWidth);
		my.setOption("lineColor", options.lineColor);
		return my.myself;
	};

	my.buildSeriesOption = function () {
		const options = my.buildOptions();

		// Apply extensions for points
		if (options.data) {
			options.data.forEach((data, index) => {
				if (pointOptions[index] === undefined) {
					return;
				}
				extend(data, pointOptions[index]);
			});
		}

		return options;
	};

	return that;
}

export default seriesBuilder;
